import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';
// Importação do Router
import { Redirect, Link } from 'react-router-dom';

import Overlay from '../Miscelania/Overlay';
import getLocale from '../../i18n/getLocale';

class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      username: '',
      password: '',
      mensagem: null,
      forget_password: false,
      ssoLoading: false,
    };
    // Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.login = this.login.bind(this);
    this.startMicrosoftLogin = this.startMicrosoftLogin.bind(this);
    this.handleSsoMessage = this.handleSsoMessage.bind(this);
    this.processAuthResponse = this.processAuthResponse.bind(this);

    this.locale = getLocale();
    this.ssoWindow = null;
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidUpdate(prevProps, prevState) {
    this.handleMessage();
  }

  componentDidMount() {
    this.handleMessage();
    window.addEventListener('message', this.handleSsoMessage);
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.handleSsoMessage);
    if (this.ssoWindow && !this.ssoWindow.closed) {
      this.ssoWindow.close();
    }
    this.ssoWindow = null;
  }


  startMicrosoftLogin(event) {
    event.preventDefault();

    if (this.state.ssoLoading) {
      return;
    }

    const apiBase = config.get('api');
    if (!apiBase) {
      this.handleAlert('Configuração de login com Microsoft indisponível.', 'error', 'open');
      return;
    }

    const origin = window.location.origin || '';
    const url = apiBase + '/auth/microsoft/redirect?system=sigtrip&origin=' + encodeURIComponent(origin);

    this.handleAlert('', '', 'open');

    const popup = window.open(url, 'sigtrip_microsoft_login', 'width=640,height=720');
    if (!popup) {
      this.handleAlert('Não foi possível abrir a janela de login da Microsoft. Verifique o bloqueio de pop-ups.', 'error', 'open');
      this.setState({ ssoLoading: false });
      return;
    }

    this.ssoWindow = popup;
    this.setState({ ssoLoading: true });
  }

  handleSsoMessage(event) {
    const payload = event.data || {};
    if (!payload || payload.type !== 'sigtrip:sso:microsoft') {
      return;
    }

    const allowedOrigins = [];
    const appendOrigin = (value) => {
      if (!value) {
        return;
      }
      const parser = document.createElement('a');
      parser.href = value;
      const origin = parser.protocol + '//' + parser.host;
      if (origin && allowedOrigins.indexOf(origin) === -1) {
        allowedOrigins.push(origin);
      }
    };

    appendOrigin(config.get('api'));
    appendOrigin(config.get('auth'));

    if (allowedOrigins.length && allowedOrigins.indexOf(event.origin) === -1) {
      return;
    }

    if (this.ssoWindow && !this.ssoWindow.closed) {
      this.ssoWindow.close();
    }
    this.ssoWindow = null;

    this.processAuthResponse(payload.data || null);
  }

  processAuthResponse(responseJson) {
    this.setState({ ssoLoading: false });

    if (!responseJson) {
      this.handleAlert('Ocorreu um erro inesperado ao processar a autenticação.', 'error', 'open');
      return;
    }

    this.refs.request_api.validate(responseJson);

    if (responseJson.error === 'inexistent_user') {
      this.handleAlert(this.locale.Usuarios.Login.usuarioNaoCadastrado, 'error', 'open');
    } else if (responseJson.error === 'inactive_user') {
      this.handleAlert(this.locale.Usuarios.Login.usuarioInativo, 'error', 'open');
    } else if (responseJson.error === 'permissionless_user') {
      this.handleAlert(this.locale.Usuarios.Login.usuarioSemPermissoes, 'error', 'open');
    } else if (responseJson.error === 'invalid_credentials' || responseJson.error === 'invalid_request' || (responseJson.data && responseJson.data.token === '{"error":"invalid_credentials","message":"The user credentials were incorrect."}')) {
      this.handleAlert(this.locale.Usuarios.Login.usuarioOuSenhaInvalidos, 'error', 'open');
    } else if (responseJson.error === 'socialite_error' || responseJson.error === 'missing_email' || responseJson.error === 'token_issue') {
      this.handleAlert(responseJson.message || this.locale.Usuarios.Login.usuarioOuSenhaInvalidos, 'error', 'open');
    } else {
      var now = new Date();
      var now_date = now.toISOString().slice(0,10);
      var now_hr = now.toISOString().slice(11,19);
      now = now_date + ' ' + now_hr;

      var token;
      try {
        token = JSON.parse(responseJson.data.token);
      } catch (error) {
        this.handleAlert('Não foi possível interpretar os dados de autenticação recebidos.', 'error', 'open');
        return;
      }

      var storage = {
        rcode: token.refresh_token,
        acode: token.access_token,
        system: 'sigtrip',
        last_update: now,
      };
      localStorage.setItem("cid", JSON.stringify(storage));

      var email = this.state.username;
      if (responseJson.data && responseJson.data.email) {
        email = responseJson.data.email;
      }

      var data = {
        email: email,
      };
      localStorage.setItem("data", JSON.stringify(data));

      var url = responseJson.data.redirect.sigtrip;
      if (url === null || typeof url === 'undefined') {
        url = '/';
      }

      this.handleAlert('', '', 'closed');
      this.setState({redirect_url: url, username: email});
    }
  }

  login(event) {
    event.preventDefault();
    var headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    };
    var datasave = {
      username: this.state.username,
      password: this.state.password,
      system: 'sigtrip',
    };
    this.handleAlert('', '', 'open');
    fetch(config.get('api') + '/get/token', { method: 'POST', mode: 'cors', headers: headers, body: JSON.stringify(datasave) })
      .then((response) => response.json())
      .then((responseJson) => {
        this.processAuthResponse(responseJson);
      })
      .catch((error) => {
      console.error(error);
      });
  }

  render() {
    return (
<div>
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <RequestApi ref={'request_api'} />
  <div className="user-wrapper visible-xs-block visible-sm-block visible-md-block" style={{backgroundImage: "url('" + config.get('cdn') + "/images/modal_background.png')"}}>
    <div className="user-wrapper" style={{backgroundImage: "url('" + config.get('cdn') + "/images/modal_background.png')"}}>
    <div className="user-layer">
      <div className="container">
        <div className="row">
          <div className="col-md-4 col-md-offset-4">
            <div className="user-content text-center">
                <img src={config.get('cdn') + '/images/logo2.png'} alt="PORTAL" />
                <p className="bg-primary"><i className="fa fa-tint"></i> {this.locale.Usuarios.Login.paragrafoFuelApp}</p>
                <form onSubmit={this.login} autoComplete="off">
                <div className="form-group">
                  <div className="input-group">
                    <div className="input-group-addon"><i className="fa fa-fw fa-at"></i></div>
                      <input autoComplete="off" type="text" name="username" className="form-control" placeholder={this.locale.Usuarios.Login.formulario.placeholder.SeuEmail} value={this.state.username} onChange={this.handleChange.bind(this, 'username')} />
                  </div>
                </div>
                <div className="form-group">
                  <div className="input-group">
                    <div className="input-group-addon"><i className="fa fa-fw fa-lock"></i></div>
                      <input autoComplete="off" type="password" name="password" className="form-control" placeholder={this.locale.Usuarios.Login.formulario.placeholder.SuaSenha} value={this.state.password} onChange={this.handleChange.bind(this, 'password')} />
                  </div>
                </div>
                {
                  config.get('development') &&
                  <p className="bg-danger"><i className="fa fa fa-warning"></i><span style={{color: 'red'}}> {this.locale.Usuarios.Login.formulario.paragrafoAtencao} </span><i className="fa fa fa-warning"></i></p>
                }
                <button className="btn btn-success btn-block" type="submit"><i className="fa fa-fw fa-sign-in"></i> {this.locale.Usuarios.Login.formulario.botaoAcessarOSistema}</button>
                <button className="btn btn-default btn-block" type="button" onClick={this.startMicrosoftLogin} disabled={this.state.ssoLoading}>
                  <i className="fa fa-fw fa-windows"></i> Entrar com Microsoft
                </button>
              </form>
              <p className="bg-primary">{this.locale.Usuarios.Login.paragrafoOLoginDeveSerFeitoComUsuarioESenhaOmniRubi}</p>
              <div className="row">
                <div className="col-md-5">
                  <p className="versao-login">v1.1.5 - 22/08/2019</p>
                </div>
                <div className="col-md-7">
                  <p className="text-right"><span onClick={() => {this.setState({ forget_password: true })} } className="link-recuperar-senha">{this.locale.Usuarios.Login.paragrafoEsqueciMinhaSenha}</span></p>
                </div>
              </div>
                {this.state.forget_password ? <span className="label label-danger">{this.locale.Usuarios.Login.paragrafoEntreEmContato}</span> : ''}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div className="user-wrapper hidden-xs hidden-sm hidden-md" style={{backgroundImage: "url('" + config.get('cdn') + "/images/modal_background.png'), url('" + config.get('cdn') + "/images/fundo-login.jpg')"}}>
    <div className="user-wrapper" style={{backgroundImage: "url('" + config.get('cdn') + "/images/modal_background.png'), url('" + config.get('cdn') + "/images/fundo-login.jpg')"}}>
    <div className="user-layer">
      <div className="container">
        <div className="row">
          <div className="col-md-4 col-md-offset-4">
            <div className="user-content text-center">
                <img src={config.get('cdn') + '/images/logo2.png'} alt="PORTAL" />
                <p className="bg-primary"><i className="fa fa-tint"></i> {this.locale.Usuarios.Login.paragrafoFuelApp}</p>
                <form onSubmit={this.login} autoComplete="off">
                <div className="form-group">
                  <div className="input-group">
                    <div className="input-group-addon"><i className="fa fa-fw fa-at"></i></div>
                      <input type="text" name="username" className="form-control" placeholder={this.locale.Usuarios.Login.formulario.placeholder.SeuEmail} autoComplete="off" value={this.state.username} onChange={this.handleChange.bind(this, 'username')} />
                  </div>
                </div>
                <div className="form-group">
                  <div className="input-group">
                    <div className="input-group-addon"><i className="fa fa-fw fa-lock"></i></div>
                      <input type="password" name="password" className="form-control" placeholder={this.locale.Usuarios.Login.formulario.placeholder.SuaSenha} autoComplete="off" value={this.state.password} onChange={this.handleChange.bind(this, 'password')} />
                  </div>
                </div>
                {
                  config.get('development') &&
                  <p className="bg-danger"><i className="fa fa fa-warning"></i><span style={{color: 'red'}}> {this.locale.Usuarios.Login.formulario.paragrafoAtencao} </span><i className="fa fa fa-warning"></i></p>
                }
                <button className="btn btn-success btn-block" type="submit"><i className="fa fa-fw fa-sign-in"></i> {this.locale.Usuarios.Login.formulario.botaoAcessarOSistema}</button>
                <button className="btn btn-default btn-block" type="button" onClick={this.startMicrosoftLogin} disabled={this.state.ssoLoading}>
                  <i className="fa fa-fw fa-windows"></i> Entrar com Microsoft
                </button>
              </form>
              <p className="bg-primary">{this.locale.Usuarios.Login.paragrafoOLoginDeveSerFeitoComUsuarioESenhaOmniRubi}</p>
              <div className="row">
                <div className="col-md-5">
                  <p className="versao-login">v0.1.12 - 22/06/2017</p>
                </div>
                <div className="col-md-7">
                  <p className="text-right"><span onClick={() => {this.setState({ forget_password: true })} } className="link-recuperar-senha">{this.locale.Usuarios.Login.paragrafoEsqueciMinhaSenha}</span></p>
                </div>
              </div>
                {this.state.forget_password ? <span className="label label-danger">{this.locale.Usuarios.Login.paragrafoEntreEmContato}</span> : ''}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/Components/Users/Login.js